console.log("🎯 JS v7.1 - PRICE PROTECTION + VARIANT IMAGE SWITCHING");

class ATCProductPL {
  constructor(container) {
    console.log("🎹 ATCProductPL initialized!", container);
    this.container = container;
    this.setupElements();
    this.bindEvents();
    this.init();
  }

  setupElements() {
    this.variantInputs = this.container.querySelectorAll("[data-variant-id]");
    this.variantHiddenInput = this.container.querySelector(
      "[data-variant-input]"
    );

    // Get ALL price display elements
    this.priceDisplays = this.container.querySelectorAll("[data-price-display]");
    this.priceDisplay = this.priceDisplays[0]; // Keep reference to first one for compatibility

    this.installmentPrice = this.container.querySelector(
      "[data-installment-price]"
    );

    console.log("📍 Price display elements found:", this.priceDisplays.length, this.priceDisplays);
    console.log("📍 First price display:", this.priceDisplay);

    this.form = this.container.querySelector("[data-product-form]");
    this.faqItems = Array.from(
      this.container.querySelectorAll(".atc-product-pl__faq")
    );
    this.faqQuestions = Array.from(
      this.container.querySelectorAll(".atc-product-pl__faq-question")
    );
    this.galleryGrid = this.container.querySelector(
      ".atc-product-pl__gallery-grid"
    );
    this.prevButton = this.container.querySelector(
      ".atc-product-pl__gallery-nav-prev"
    );
    this.nextButton = this.container.querySelector(
      ".atc-product-pl__gallery-nav-next"
    );
    this.currentSlide = 0;

    // Sticky bar elements
    this.stickyBar = this.container.querySelector("[data-sticky-bar]");
    this.stickyForm = this.container.querySelector("[data-sticky-form]");
    this.stickyVariantInput = this.container.querySelector(
      "[data-sticky-variant-input]"
    );
    this.stickyPriceDisplay = this.container.querySelector(
      "[data-sticky-price-display]"
    );
    this.stickyComparePrice = this.container.querySelector(
      "[data-sticky-compare-price]"
    );
    this.stickyVariantName = this.container.querySelector(
      "[data-sticky-variant-name]"
    );
    this.mainButton = this.container.querySelector(".atc-product-pl__button");

    // Piano Pack specific elements
    this.pianoInputs = this.container.querySelectorAll("[data-piano-style]");
    this.ledInputs = this.container.querySelectorAll("[data-led-color]");
    this.variantsDataScript = this.container.querySelector("[data-variants-json]");
    this.variants = [];
    this.selectedPiano = null;
    this.selectedLed = null;
    this.comparePriceDisplay = this.container.querySelector("[data-compare-price]");
    this.pianoIsOption1 = false;
    this.pianoIsOption2 = false;
    this.ledIsOption1 = false;
    this.ledIsOption2 = false;

    // Load variants data if available
    if (this.variantsDataScript) {
      try {
        const data = JSON.parse(this.variantsDataScript.textContent);
        this.variants = data.variants || [];
        this.pianoIsOption1 = data.pianoIsOption1 || false;
        this.pianoIsOption2 = data.pianoIsOption2 || false;
        this.ledIsOption1 = data.ledIsOption1 || false;
        this.ledIsOption2 = data.ledIsOption2 || false;
        if (this.variants.length > 0) {
          console.log("Loaded piano pack variants:", this.variants.length);
          console.log("Piano is option1:", this.pianoIsOption1, "option2:", this.pianoIsOption2);
          console.log("LED is option1:", this.ledIsOption1, "option2:", this.ledIsOption2);
        }
      } catch (e) {
        console.error("Failed to parse variants data:", e);
      }
    }
  }

  bindEvents() {
    // Piano Pack: Piano style selection
    if (this.pianoInputs.length > 0) {
      console.log("Attaching piano change events to", this.pianoInputs.length, "inputs");
      this.pianoInputs.forEach((input) => {
        input.addEventListener("change", this.handlePianoChange.bind(this));
      });
    }

    // Piano Pack: LED color selection
    if (this.ledInputs.length > 0) {
      console.log("Attaching LED change events to", this.ledInputs.length, "inputs");
      this.ledInputs.forEach((input) => {
        input.addEventListener("change", this.handleLedChange.bind(this));
      });
    }

    // Original variant inputs (for non-piano-pack products)
    console.log("📻 Attaching change events to variant inputs:", this.variantInputs.length);
    this.variantInputs.forEach((input) => {
      input.addEventListener("change", this.handleVariantChange.bind(this));
      console.log("  - Event attached to input:", input);
    });

    if (this.form) {
      this.form.addEventListener("submit", this.handleFormSubmit.bind(this));
    }

    this.faqQuestions.forEach((question) => {
      question.addEventListener("click", (e) => this.handleQuestionClick(e));
    });

    if (this.prevButton) {
      this.prevButton.addEventListener(
        "click",
        this.handlePrevSlide.bind(this)
      );
    }

    if (this.nextButton) {
      this.nextButton.addEventListener(
        "click",
        this.handleNextSlide.bind(this)
      );
    }

    window.addEventListener("resize", this.handleResize.bind(this));

    // Sticky bar events
    if (this.stickyForm) {
      this.stickyForm.addEventListener(
        "submit",
        this.handleFormSubmit.bind(this)
      );
    }

    // Sticky bar scroll detection
    window.addEventListener("scroll", this.handleStickyScroll.bind(this), {
      passive: true,
    });
  }

  init() {
    this.initSwiper();
    this.initFAQs();
    this.initShippingCalculator();
    this.initStickyBar();
    this.initPlaylistModal();
    this.initCountdownBar();

    // Initialize piano pack selections if available
    if (this.pianoInputs.length > 0 && this.ledInputs.length > 0) {
      console.log("Initializing piano pack with", this.pianoInputs.length, "piano options and", this.ledInputs.length, "LED options");

      const checkedPiano = this.container.querySelector("[data-piano-style]:checked");
      const checkedLed = this.container.querySelector("[data-led-color]:checked");

      if (checkedPiano) this.selectedPiano = checkedPiano.value;
      if (checkedLed) this.selectedLed = checkedLed.value;

      console.log("Initial selection:", { piano: this.selectedPiano, led: this.selectedLed });

      this.updatePianoPackVariantSelection();
    }
  }

  initSwiper() {
    // Initialize Swiper only on mobile
    if (window.innerWidth > 990) return;

    if (typeof Swiper === "undefined") {
      console.error("Swiper library not loaded");
      return;
    }

    if (this.galleryGrid) {
      this.swiper = new Swiper(this.galleryGrid, {
        slidesPerView: "auto",
        spaceBetween: 8,
        centeredSlides: false,
        loop: true,
        grabCursor: true,
        slideToClickedSlide: true,
        breakpoints: {
          991: {
            enabled: false,
          },
        },
      });
    }
  }

  handleResize() {
    const isMobile = window.innerWidth <= 990;

    if (isMobile && !this.swiper) {
      // Initialize Swiper on mobile if not already initialized
      this.initSwiper();
    } else if (!isMobile && this.swiper) {
      // Destroy Swiper on desktop
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  handlePrevSlide() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  handleNextSlide() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  handleVariantChange(event) {
    console.log("🔄 handleVariantChange triggered!");
    const input = event.target;
    const variantId = input.dataset.variantId;
    const variantPrice = parseInt(input.dataset.variantPrice);
    const variantTitle = input
      .closest(".atc-product-pl__variant-option")
      ?.querySelector(".p-medium-medium")?.textContent;

    console.log("Variant changed:", { variantId, variantPrice, variantTitle });

    this.variantInputs.forEach((inp) => {
      const label = inp.closest(".atc-product-pl__variant-option");
      if (label) {
        label.classList.remove("atc-product-pl__variant-option--selected");
      }
    });

    const selectedLabel = input.closest(".atc-product-pl__variant-option");
    if (selectedLabel) {
      selectedLabel.classList.add("atc-product-pl__variant-option--selected");
    }

    if (this.variantHiddenInput) {
      this.variantHiddenInput.value = variantId;
    }

    // Update ALL prices DIRECTLY + setup protection against external scripts
    if (variantPrice) {
      const formattedPrice = this.formatMoney(variantPrice);
      const installment = Math.floor(variantPrice / 3);
      const formattedInstallment = this.formatMoney(installment);

      // Store expected prices for protection
      this._expectedMainPrice = formattedPrice;
      this._expectedInstallmentPrice = formattedInstallment;

      // Store price globally for continuous protection
      window._currentVariantPrice = formattedPrice;
      window._currentInstallmentPrice = formattedInstallment;

      // Function to apply prices - uses DOCUMENT selector for reliability
      const applyPrices = () => {
        // Target ALL price elements in document (not just container)
        const allPriceElements = document.querySelectorAll('[data-price-display]');
        if (allPriceElements.length > 0) {
          allPriceElements.forEach((priceEl) => {
            priceEl.textContent = formattedPrice;
            priceEl.innerHTML = formattedPrice;
          });
        }

        // Hide compare price if swapped
        const allCompareElements = document.querySelectorAll('[data-compare-price]');
        allCompareElements.forEach((compareEl) => {
          if (compareEl.textContent.trim() === formattedPrice) {
            compareEl.style.display = "none";
          }
        });

        // Update installment
        const installmentEl = document.querySelector('[data-installment-price]');
        if (installmentEl) {
          installmentEl.textContent = formattedInstallment;
        }

        // Update sticky
        const stickyPriceEl = document.querySelector('[data-sticky-price-display]');
        if (stickyPriceEl) {
          stickyPriceEl.textContent = formattedPrice;
        }

        // Update header prices
        const headerPriceEl = document.querySelector('[data-header-price]');
        if (headerPriceEl) {
          headerPriceEl.textContent = formattedPrice;
        }
      };

      // Apply immediately
      applyPrices();
      console.log("✅ DOCUMENT-WIDE price update:", formattedPrice);

      // Clear previous interval
      if (this._priceProtectionInterval) {
        clearInterval(this._priceProtectionInterval);
      }

      // Re-apply EVERY 50ms INDEFINITELY (until next variant change)
      this._priceProtectionInterval = setInterval(() => {
        applyPrices();
      }, 50);
    }

    // Sync variant inputs with sticky bar
    if (this.stickyVariantInput) {
      this.stickyVariantInput.value = variantId;
    }

    if (this.stickyVariantName && variantTitle) {
      this.stickyVariantName.textContent = variantTitle;
    }
  }

  // Obsolete functions removed - now using direct price updates in handleVariantChange and updatePianoPackVariantSelection

  

  formatMoney(cents) {
    const euros = (cents / 100).toFixed(2);
    // Format Shopify: "€569,00" (euro au début, comme dans le template Liquid)
    return "€" + euros.replace(".", ",");
  }

  handlePianoChange(event) {
    const input = event.target;
    this.selectedPiano = input.value;
    console.log("Piano changed to:", this.selectedPiano);
    this.updatePianoPackVariantSelection();
  }

  handleLedChange(event) {
    const input = event.target;
    this.selectedLed = input.value;
    console.log("🔵 LED changed to:", this.selectedLed, "| Piano:", this.selectedPiano);

    // Update LED option selected state (only within LED options container)
    const ledContainer = this.container.querySelector("[data-led-options]");
    if (ledContainer) {
      const allLedOptions = ledContainer.querySelectorAll(".atc-product-pl__variant-option");
      allLedOptions.forEach((option) => {
        option.classList.remove("atc-product-pl__variant-option--selected");
      });

      const selectedLabel = input.closest(".atc-product-pl__variant-option");
      if (selectedLabel) {
        selectedLabel.classList.add("atc-product-pl__variant-option--selected");
      }
    }

    this.updatePianoPackVariantSelection();
  }

  updatePianoPackVariantSelection() {
    if (!this.selectedPiano || !this.selectedLed || this.variants.length === 0) {
      console.log("Piano pack selection incomplete:", {
        piano: this.selectedPiano,
        led: this.selectedLed,
        variantsCount: this.variants.length
      });
      return;
    }

    // Find matching variant (adapt based on option structure)
    let variant;
    if (this.pianoIsOption1 && this.ledIsOption2) {
      // Piano in option1, LED in option2
      variant = this.variants.find(
        (v) => v.option1 === this.selectedPiano && v.option2 === this.selectedLed
      );
    } else if (this.pianoIsOption2 && this.ledIsOption1) {
      // LED in option1, Piano in option2
      variant = this.variants.find(
        (v) => v.option1 === this.selectedLed && v.option2 === this.selectedPiano
      );
    } else {
      // Fallback: try both combinations
      variant = this.variants.find(
        (v) =>
          (v.option1 === this.selectedPiano && v.option2 === this.selectedLed) ||
          (v.option1 === this.selectedLed && v.option2 === this.selectedPiano)
      );
    }

    if (!variant) {
      console.error("No variant found for:", {
        piano: this.selectedPiano,
        led: this.selectedLed,
        pianoIsOption1: this.pianoIsOption1,
        pianoIsOption2: this.pianoIsOption2,
        availableVariants: this.variants.map(v => ({ option1: v.option1, option2: v.option2 }))
      });
      return;
    }

    console.log("Matched variant:", variant.id, "Price:", variant.price, "Structure:", {
      pianoIsOption1: this.pianoIsOption1,
      ledIsOption1: this.ledIsOption1
    });

    // Update hidden inputs
    if (this.variantHiddenInput) {
      this.variantHiddenInput.value = variant.id;
    }

    if (this.stickyVariantInput) {
      this.stickyVariantInput.value = variant.id;
    }

    // Update ALL prices with protection against external scripts
    const price = variant.price;
    const comparePrice = variant.compare_at_price;

    console.log("💰 Piano pack price update with protection:", {
      price,
      comparePrice
    });

    const formattedPrice = this.formatMoney(price);
    const formattedComparePrice = comparePrice ? this.formatMoney(comparePrice) : null;
    const installment = Math.floor(price / 3);
    const formattedInstallment = this.formatMoney(installment);

    // Store prices globally
    window._currentVariantPrice = formattedPrice;
    window._currentComparePrice = formattedComparePrice;
    window._currentInstallmentPrice = formattedInstallment;

    // Function to apply ALL prices using DOCUMENT selectors
    const applyPrices = () => {
      // Force main CTA prices (all elements in document)
      const allPriceElements = document.querySelectorAll('[data-price-display]');
      allPriceElements.forEach((priceEl) => {
        priceEl.textContent = formattedPrice;
        priceEl.innerHTML = formattedPrice;
      });

      // Manage compare prices
      const allCompareElements = document.querySelectorAll('[data-compare-price]');
      allCompareElements.forEach((compareEl) => {
        if (compareEl.textContent.trim() === formattedPrice) {
          // Hide if swapped
          compareEl.style.display = "none";
        } else if (comparePrice && comparePrice > price && formattedComparePrice) {
          // Show real compare price
          compareEl.textContent = formattedComparePrice;
          compareEl.style.display = "";
        } else {
          compareEl.style.display = "none";
        }
      });

      // Update installment
      const installmentEl = document.querySelector('[data-installment-price]');
      if (installmentEl) {
        installmentEl.textContent = formattedInstallment;
      }

      // Update sticky prices
      const stickyPriceEl = document.querySelector('[data-sticky-price-display]');
      if (stickyPriceEl) {
        stickyPriceEl.textContent = formattedPrice;
      }

      const stickyCompareEl = document.querySelector('[data-sticky-compare-price]');
      if (stickyCompareEl) {
        if (comparePrice && comparePrice > price && formattedComparePrice) {
          stickyCompareEl.textContent = formattedComparePrice;
          stickyCompareEl.style.display = "";
        } else {
          stickyCompareEl.style.display = "none";
        }
      }

      // Update header prices
      const headerPriceEl = document.querySelector('[data-header-price]');
      if (headerPriceEl) {
        headerPriceEl.textContent = formattedPrice;
      }

      const headerCompareEl = document.querySelector('[data-header-compare-price]');
      const headerDiscountEl = document.querySelector('.atc-product-pl__header-discount-badge');
      if (headerCompareEl) {
        if (comparePrice && comparePrice > price && formattedComparePrice) {
          headerCompareEl.textContent = formattedComparePrice;
          headerCompareEl.style.display = "";
          if (headerDiscountEl) {
            const discountPercent = Math.round((comparePrice - price) / comparePrice * 100);
            headerDiscountEl.textContent = `-${discountPercent}%`;
            headerDiscountEl.style.display = "";
          }
        } else {
          headerCompareEl.style.display = "none";
          if (headerDiscountEl) {
            headerDiscountEl.style.display = "none";
          }
        }
      }
    };

    // Apply immediately
    applyPrices();
    console.log("✅ Piano pack DOCUMENT-WIDE update:", formattedPrice);

    // Clear previous interval
    if (this._priceProtectionInterval) {
      clearInterval(this._priceProtectionInterval);
    }

    // Re-apply EVERY 50ms INDEFINITELY
    this._priceProtectionInterval = setInterval(() => {
      applyPrices();
    }, 50);

    // Update variant name in sticky bar
    if (this.stickyVariantName) {
      this.stickyVariantName.textContent = this.selectedLed;
    }

    // Update main product image if available
    if (variant.featured_image) {
      const mainImage = this.container.querySelector(".atc-product-pl__gallery-item:first-child img");
      if (mainImage) {
        mainImage.src = variant.featured_image;
      }
    }
  }

  async handleFormSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const variantId = formData.get("id");
    const button = this.form.querySelector(".atc-product-pl__button");

    button.setAttribute("disabled", "disabled");

    try {
      const sectionsToBundle = [];
      document.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sectionsToBundle.join(","),
        }),
      });

      if (response.ok) {
        const data = await response.json();

        document.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              variant: data,
              cart: data,
            },
          })
        );

        document.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: data,
            },
          })
        );

        this.showSuccess();
        button.removeAttribute("disabled");
      } else {
        this.showError();
        button.removeAttribute("disabled");
      }
    } catch (error) {
      this.showError();
      button.removeAttribute("disabled");
    }
  }

  showSuccess() {
    const button = this.form.querySelector(".atc-product-pl__button");
    const originalText = button.innerHTML;
    button.innerHTML = '<span style="color: white;">✓ AJOUTÉ AU PANIER</span>';
    setTimeout(() => {
      button.innerHTML = originalText;
    }, 2000);
  }

  showError() {
    const button = this.form.querySelector(".atc-product-pl__button");
    const originalText = button.innerHTML;
    button.innerHTML = '<span style="color: white;">ERREUR</span>';
    setTimeout(() => {
      button.innerHTML = originalText;
    }, 2000);
  }

  initFAQs() {
    this.faqItems.forEach((item) => {
      item.classList.remove("atc-product-pl__faq--active");
      const question = item.querySelector(".atc-product-pl__faq-question");
      if (question) {
        question.setAttribute("aria-expanded", "false");
      }
      const answer = item.querySelector(".atc-product-pl__faq-answer");
      if (answer) {
        answer.setAttribute("aria-hidden", "true");
      }
    });
  }

  handleQuestionClick(e) {
    const button = e.currentTarget;
    const item = button.closest(".atc-product-pl__faq");

    if (!item) return;

    const isActive = item.classList.contains("atc-product-pl__faq--active");

    if (isActive) {
      this.closeFAQItem(item);
    } else {
      this.openFAQItem(item);
    }
  }

  openFAQItem(item) {
    item.classList.add("atc-product-pl__faq--active");

    const question = item.querySelector(".atc-product-pl__faq-question");
    if (question) {
      question.setAttribute("aria-expanded", "true");
    }

    const answer = item.querySelector(".atc-product-pl__faq-answer");
    if (answer) {
      answer.setAttribute("aria-hidden", "false");
    }
  }

  closeFAQItem(item) {
    item.classList.remove("atc-product-pl__faq--active");

    const question = item.querySelector(".atc-product-pl__faq-question");
    if (question) {
      question.setAttribute("aria-expanded", "false");
    }

    const answer = item.querySelector(".atc-product-pl__faq-answer");
    if (answer) {
      answer.setAttribute("aria-hidden", "true");
    }
  }

  initShippingCalculator() {
    const shippingCalculator = this.container.querySelector(
      "shipping-calculator"
    );
    if (!shippingCalculator) return;

    const shippingDelay =
      parseInt(shippingCalculator.dataset.shippingDelay) || 2;
    const dateElement = shippingCalculator.querySelector(
      "[data-shipping-date]"
    );

    if (dateElement) {
      const deliveryDate = this.calculateDeliveryDate(shippingDelay);
      dateElement.innerHTML = `Livraison <strong>OFFERTE</strong> | Recevez-le dès le ${deliveryDate}`;
    }
  }

  calculateDeliveryDate(daysToAdd) {
    const today = new Date();
    let daysAdded = 0;

    while (daysAdded < daysToAdd) {
      today.setDate(today.getDate() + 1);
      const dayOfWeek = today.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysAdded++;
      }
    }

    const days = [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi",
    ];
    const months = [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ];

    const dayName = days[today.getDay()];
    const dayNumber = today.getDate();
    const monthName = months[today.getMonth()];

    return `${dayName} ${dayNumber} ${monthName}`;
  }

  initStickyBar() {
    if (!this.stickyBar) return;

    // Initialize shipping calculator in sticky bar
    const stickyShippingCalculator = this.stickyBar.querySelector(
      "shipping-calculator"
    );
    if (stickyShippingCalculator) {
      const shippingDelay =
        parseInt(stickyShippingCalculator.dataset.shippingDelay) || 2;
      const dateElement = stickyShippingCalculator.querySelector(
        "[data-shipping-date]"
      );

      if (dateElement) {
        const deliveryDate = this.calculateDeliveryDate(shippingDelay);
        dateElement.innerHTML = `Recevez-le dès le <strong>${deliveryDate}</strong>`;
      }
    }

    // Initial scroll check
    this.handleStickyScroll();
  }

  handleStickyScroll() {
    if (!this.stickyBar || !this.mainButton) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const buttonRect = this.mainButton.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Check if main button is visible in viewport
    const isButtonVisible =
      buttonRect.top < windowHeight && buttonRect.bottom > 0;

    // Show sticky bar if:
    // 1. Scrolled more than 500px
    // 2. AND main button is NOT visible
    const shouldShow = scrollTop > 500 && !isButtonVisible;

    if (shouldShow) {
      this.stickyBar.classList.add("atc-product-pl__sticky-bar--visible");
    } else {
      this.stickyBar.classList.remove("atc-product-pl__sticky-bar--visible");
    }
  }

  initPlaylistModal() {
    const triggers = document.querySelectorAll(".atc-product-pl__playlist-trigger");
    if (triggers.length === 0) return;

    const modal = document.getElementById("playlistModal");
    if (!modal) return;

    const iframeContainer = modal.querySelector("[data-iframe-container]");
    const modalTitle = modal.querySelector(".playlist-modal__title");
    const tabsContainer = modal.querySelector("[data-tabs-container]");
    const tabButtons = modal.querySelectorAll("[data-tab]");
    const closeButtons = modal.querySelectorAll("[data-modal-close]");

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const playlistId = trigger.getAttribute("data-playlist-id");
        const playlistId2 = trigger.getAttribute("data-playlist-id-2");
        const playlistLabel = trigger.getAttribute("data-playlist-label") || "Premium";
        const playlistLabel2 = trigger.getAttribute("data-playlist-label-2") || "Gratuit";
        const playlistTitle = trigger.getAttribute("data-playlist-title") || "Playlist";

        window.currentPlaylistData = {
          id1: playlistId,
          id2: playlistId2,
          label1: playlistLabel,
          label2: playlistLabel2,
          title: playlistTitle,
        };

        this.openPlaylistModal(modal, iframeContainer, modalTitle, tabsContainer, tabButtons);
      });
    });

    tabButtons.forEach((tab) => {
      tab.addEventListener("click", () => {
        const tabNum = tab.getAttribute("data-tab");
        this.switchPlaylistTab(tabNum, tabButtons, iframeContainer);
      });
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.closePlaylistModal(modal, iframeContainer);
      });
    });
  }

  openPlaylistModal(modal, iframeContainer, modalTitle, tabsContainer, tabButtons) {
    const data = window.currentPlaylistData;
    if (!data) return;

    modalTitle.textContent = data.title;

    if (tabsContainer) {
      tabsContainer.style.display = "flex";
      if (tabButtons[0]) tabButtons[0].textContent = data.label1 || "Premium";
      if (tabButtons[1]) tabButtons[1].textContent = data.label2 || "Gratuit";

      if (tabButtons[1]) {
        if (data.id2 && data.id2.trim() !== "") {
          tabButtons[1].disabled = false;
          tabButtons[1].style.opacity = "";
        } else {
          tabButtons[1].disabled = true;
          tabButtons[1].style.opacity = "0.5";
        }
      }
    }

    this.loadPlaylistIframe(data.id1, iframeContainer);

    modal.setAttribute("aria-hidden", "false");
    modal.style.display = "flex";
    document.body.style.overflow = "hidden";
  }

  loadPlaylistIframe(playlistId, container) {
    if (!playlistId || !container) return;
    container.innerHTML = `<iframe src="https://widget.deezer.com/widget/dark/playlist/${playlistId}" width="100%" height="500" frameborder="0" allowtransparency="true" allow="encrypted-media; clipboard-write"></iframe>`;
  }

  switchPlaylistTab(tabNum, tabButtons, iframeContainer) {
    const data = window.currentPlaylistData;
    if (!data) return;

    tabButtons.forEach((btn) => btn.classList.remove("playlist-modal__tab--active"));

    const selectedTab = Array.from(tabButtons).find((btn) => btn.getAttribute("data-tab") === tabNum);
    if (selectedTab) {
      selectedTab.classList.add("playlist-modal__tab--active");
    }

    if (tabNum === "1") {
      this.loadPlaylistIframe(data.id1, iframeContainer);
    } else if (tabNum === "2" && data.id2) {
      this.loadPlaylistIframe(data.id2, iframeContainer);
    }
  }

  closePlaylistModal(modal, iframeContainer) {
    modal.setAttribute("aria-hidden", "true");
    modal.style.display = "none";
    document.body.style.overflow = "";
    iframeContainer.innerHTML = "";
  }

  initCountdownBar() {
    const countdownBar = this.container.querySelector(".atc-product-pl__countdown-bar");
    if (!countdownBar) return;

    const countdownDate = countdownBar.dataset.countdownDate;
    if (!countdownDate) return;

    const endDate = new Date(countdownDate.replace(" ", "T"));
    if (isNaN(endDate.getTime())) {
      console.error("Invalid countdown date:", countdownDate);
      return;
    }

    const daysEl = countdownBar.querySelector("[data-countdown-days]");
    const hoursEl = countdownBar.querySelector("[data-countdown-hours]");
    const minutesEl = countdownBar.querySelector("[data-countdown-minutes]");
    const secondsEl = countdownBar.querySelector("[data-countdown-seconds]");

    const updateCountdown = () => {
      const now = new Date();
      const diff = endDate - now;

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = "00";
        if (hoursEl) hoursEl.textContent = "00";
        if (minutesEl) minutesEl.textContent = "00";
        if (secondsEl) secondsEl.textContent = "00";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = String(days).padStart(2, "0");
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, "0");
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, "0");
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, "0");
    };

    // Update immediately
    updateCountdown();

    // Update every second
    setInterval(updateCountdown, 1000);
  }
}

console.log("🚀 w-ATC-PRODUCT-PL.js loaded!");

document.addEventListener("DOMContentLoaded", () => {
  console.log("📄 DOMContentLoaded fired!");
  const section = document.querySelector(".atc-product-pl");
  console.log("🔍 Section found:", section);

  if (section) {
    console.log("✅ Initializing ATCProductPL...");
    new ATCProductPL(section);
  } else {
    console.error("❌ Section .atc-product-pl not found!");
    console.log("Available sections:", document.querySelectorAll("section"));
  }
});

document.addEventListener("shopify:section:load", (event) => {
  const section = event.target.querySelector(".atc-product-pl");
  if (section) {
    new ATCProductPL(section);
  }
});

function showShortLed() {
  document.querySelector('.playshorts-container [class*="ps-story-item-"]:nth-child(3)').click();
}
